<template>
  <div id="full-height-container" style="height: 100%">
    <div ref="container" id="konva-container"></div>

    <div class="zoom">
      <v-btn depressed @click="zoom('in')">
        <font-awesome-icon icon="search-plus" />
      </v-btn>
      <v-btn depressed @click="zoom('out')">
        <font-awesome-icon icon="search-minus" />
      </v-btn>
    </div>
  </div>
</template>

<script>
import Stage from './components/stage'
import { xToTime, zoom } from './utils'
import { width as yScaleWidth } from './components/y-scale-layer'

export default {
  props: {
    now: Number,
    timeFrom: Number,
    timeTo: Number,
    data: Array,
    userData: Object
  },
  mounted () {
    this.fullHeightContainer = document.querySelector('#full-height-container')

    this.wheelEventListener = this.onWheel.bind(this)
    this.fullHeightContainer.addEventListener('wheel', this.wheelEventListener, {
      capture: true
    })

    this.initStage()
  },
  beforeDestroy () {
    this.fullHeightContainer.removeEventListener('wheel', this.wheelEventListener)
    if (this.stage) {
      this.stage.destroy()
    }
  },
  watch: {
    data () {
      this.initStage()
    }
  },
  methods: {
    initStage () {
      const { data, userData, timeFrom, timeTo, now, moveTime } = this
      const { container } = this.$refs
      if (!this.stage) {
        this.stage = new Stage({ container, moveTime })
      }
      this.stage.init({ data, userData, timeFrom, timeTo, now })
    },
    onWheel (event) {
      if (event.ctrlKey) {
        event.preventDefault()
        event.stopPropagation()
        const direction = event.deltaY > 0 ? 'out' : 'in'
        const x = event.offsetX
        this.zoom(direction, x)
      }
    },
    zoom (direction, x) {
      const { timeFrom, timeTo } = this
      const width = this.stage.getWidth() - yScaleWidth
      const time = x === undefined ? (timeFrom + timeTo) / 2 : xToTime({ timeFrom, timeTo, width, x })
      const newTimeInterval = zoom({ timeFrom, timeTo, time, direction })
      if (newTimeInterval) {
        this.$emit('timeInterval', newTimeInterval)
      }
    },
    moveTime (diffX) {
      const { timeFrom, timeTo } = this
      const width = this.stage.getWidth() - yScaleWidth
      const diffTime = xToTime({ timeFrom, timeTo, width, x: -diffX }) - timeFrom
      const newTimeInterval = { timeFrom: timeFrom + diffTime, timeTo: timeTo + diffTime }
      this.$emit('timeInterval', newTimeInterval)
    }
  }
}
</script>

<style scoped lang="scss">

  @import '../../assets/variables';

  .zoom {
    position: absolute;
    right: $spacing-default;
    top: $spacing-default;
    display: flex;
    flex-direction: row;

    .v-btn {
      border-radius: 0;
      &:first-child {
        border-top-left-radius: $border-radius;
        border-bottom-left-radius: $border-radius;
      }

      &:last-child {
        border-top-right-radius: $border-radius;
        border-bottom-right-radius: $border-radius;
      }
    }
  }

</style>
